import React from "react";
import {Paper} from '@material-ui/core'
import styled from "@emotion/styled";
import {PUBLIC_CND_BASEURL} from "../App";

function CarouselItem({item}) {

    return (
        <>
            <Paper>
                <IMG>
                    <img src={PUBLIC_CND_BASEURL + item.src} alt="img"/>
                </IMG>

                {/*<Content>*/}
                {/*    <div className={"flex-middle"}>*/}
                {/*        <h1>{item.heading}</h1>*/}
                {/*        <p>{item.description}</p>*/}
                {/*        <a href="/objects" className={"styled_button"}>Alle Bungalows</a>*/}
                {/*    </div>*/}
                {/*</Content>*/}
            </Paper>
        </>
    )
}

const IMG = styled.div`
  height: 100vh;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export default CarouselItem